import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { concatMap, map, of, take } from 'rxjs';
import { ICustomerService } from '../../services/customer/customer.service.interface';
import { SecurityService } from "../security.service";
import { ContextGuardService } from './context-guard.service';

export const createOrdersGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state,
  contextGuardService: ContextGuardService = inject(ContextGuardService),
  customerService: ICustomerService = inject(ICustomerService),
  securityService: SecurityService = inject(SecurityService),
  router: Router = inject(Router)
) => {
  return contextGuardService.canActivate(route).pipe(
    take(1),
    concatMap(contextGuardResult => {
      if (contextGuardResult !== true) {
        return of(contextGuardResult);
      }

      return securityService.getCurrentAccount().pipe(
        take(1),
        concatMap(account => {
          if (!account) {
            return of(router.parseUrl('/'));
          }

          return customerService.isAgentSalesCustomer(account.AXCode).pipe(
            map(isAgentSalesCustomer => {
              if (isAgentSalesCustomer) {
                return router.parseUrl(`/account/${account.AXCode}`);
              } else {
                return true;
              }
            })
          );
        })
      );
    })
  );
};
